import React, { useState } from "react";
import { TheFooterFunction } from "./Footer";
import images from "./images/majors-list.jpg";
import FilterImage from "./images/filter.png";
import data from "./data/dataSet.json";
import { TheNavbar } from "./Navbar";

function SearchBar({
  searchTerm,
  setSearchTerm,
  handleSearch,
  clearSearch,
  toggleFilters,
}) {
  return (
    <div className="search-bar-body p-2 d-flex">
      <p className="mb-0 flex-grow-1">Search any major/category:</p>
      <input
        type="text"
        className="form-control"
        placeholder="Enter your search"
        onChange={(e) => setSearchTerm(e.target.value)}
        value={searchTerm}
        onKeyDown={(e) => {
          if (e.key === "Enter") {
            handleSearch();
          }
        }}
      />
      <button className="btn ms-2 button-back" onClick={handleSearch}>
        Search
      </button>
      {searchTerm && (
        <button
          className="btn btn-outline-secondary ms-2"
          onClick={clearSearch}
        >
          Clear
        </button>
      )}
      <button className="btn  ms-2 button-back" onClick={toggleFilters}>
        <img src={FilterImage} alt="Filter Image Icon" className="filter-img" />
      </button>
    </div>
  );
}

function Categories({ data, selectedCategories, handleCategoryToggle }) {
  // Prepare category checkboxes content before return
  const categoryCheckboxes = data.categories.map((category, index) => {
    const isChecked = selectedCategories.includes(category.name);
    return (
      <div key={index} className="category-checkbox">
        <div className="form-check">
          <input
            className="form-check-input"
            type="checkbox"
            checked={isChecked}
            onChange={() => handleCategoryToggle(category.name)}
            id={`category${index + 1}`}
          />
          <label className="form-check-label" htmlFor={`category${index + 1}`}>
            {category.name}
          </label>
        </div>
      </div>
    );
  });

  return (
    <section className="mb-4">
      <div className="categories-body p-4">
        <h5 className="card-title mb-2">Categories</h5>
        <div className="flex-wrap">{categoryCheckboxes}</div>
      </div>
    </section>
  );
}

function SearchResult({ searchedMajor, notFoundMessage }) {
  if (searchedMajor) {
    return (
      <div className="mb-4">
        <div className="card">
          <div className="card-header">Search Result</div>
          <div className="card-body">
            <h5 className="card-title">{searchedMajor.name + ":"}</h5>
            <p className="card-text">{searchedMajor.description}</p>
            <p>Top Schools: {searchedMajor.topSchools.join(", ")}</p>
            <a
              href={searchedMajor.wikiLink}
              target="_blank"
              rel="noopener noreferrer"
              className="btn button-back"
            >
              Learn more
            </a>
          </div>
        </div>
      </div>
    );
  } else if (notFoundMessage) {
    return (
      <div className="mb-4">
        <div className="card">
          <div className="card-header">Search Result</div>
          <div className="card-body">
            <p>{notFoundMessage}</p>
          </div>
        </div>
      </div>
    );
  }
  return null;
}

function ExploreSection({ data, selectedCategories, setSearchedMajor }) {
  // Filter categories first if there are selected categories
  const filteredCategories = data.categories.filter(
    (category) =>
      selectedCategories.length === 0 ||
      selectedCategories.includes(category.name)
  );

  // Prepare categories and majors content before return
  const categoriesContent = filteredCategories.map((category, index) => (
    <div key={index} className="col-md-4 mb-3">
      <div className="card">
        <div className="card-header">{category.name}</div>
        <div className="card-body">
          <ul className="list-unstyled">
            {category.majors.map((major, idx) => (
              <li
                key={idx}
                onClick={() => setSearchedMajor(major)}
                className="cursor-pointer"
              >
                {major.name}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  ));

  return (
    <div className="explore-sect">
      <p>
        Explore the major sections below to learn about each major in REAL
        depth!
      </p>
      <div className="container">
        <div className="row">{categoriesContent}</div>
      </div>
    </div>
  );
}

export function TheSearchPage() {
  const [showFilters, setShowFilters] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchedMajor, setSearchedMajor] = useState(null);
  const [notFoundMessage, setNotFoundMessage] = useState(null);

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  const handleCategoryToggle = (categoryName) => {
    if (selectedCategories.includes(categoryName)) {
      setSelectedCategories(
        selectedCategories.filter((cat) => cat !== categoryName)
      );
    } else {
      setSelectedCategories([...selectedCategories, categoryName]);
    }
  };

  const handleSearch = () => {
    setSearchedMajor(null); // Reset searchedMajor when searching again
    setNotFoundMessage(null); // Reset not found message

    if (searchTerm.trim() === "") {
      return; // Do not proceed with search
    }
    const lowercaseSearchTerm = searchTerm.toLowerCase();
    let found = false;
    data.categories.forEach((category) => {
      category.majors.forEach((major) => {
        if (major.name.toLowerCase() === lowercaseSearchTerm) {
          setSearchedMajor(major);
          found = true;
        }
      });
    });
    if (!found) {
      setNotFoundMessage(`Major "${searchTerm}" not found.`);
    }
  };

  const clearSearch = () => {
    setSearchTerm("");
    setSearchedMajor(null);
    setNotFoundMessage(null);
  };

  return (
    <div>
      {" "}
      <TheNavbar />
        <div className="container-fluid p-0">
          <img
            src={images}
            alt="Image of different Technologies/Items"
            className="img-fluid"
          />
        </div>

        <section className="mb-4 row mb-3">
          <h2 className="visually-hidden">Major Search</h2>
          <SearchBar
            searchTerm={searchTerm}
            setSearchTerm={setSearchTerm}
            handleSearch={handleSearch}
            clearSearch={clearSearch}
            toggleFilters={toggleFilters}
          />
        </section>

        {showFilters && (
          <Categories
            data={data}
            selectedCategories={selectedCategories}
            handleCategoryToggle={handleCategoryToggle}
          />
        )}

        <SearchResult
          searchedMajor={searchedMajor}
          notFoundMessage={notFoundMessage}
        />

        <ExploreSection
          data={data}
          selectedCategories={selectedCategories}
          setSearchedMajor={setSearchedMajor}
        />
      <TheFooterFunction />
    </div>
  );
}
